import React, { Component } from 'react'
import { Redirect } from 'react-router'
import { UserIsAuthenticated } from 'utils/RouteGuards'

@UserIsAuthenticated
class Home extends Component {
  render () {
    return <Redirect to='/add' />
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/routes/Home/index.js